export enum ProductType {
  Regular = 'regular',
  Pseudo = 'pseudo'
}
